function validateTerms() {
    var validators = $('.registrationTermsValidator');
    for (var i = 0; i < validators.length; i++) {
        var validator = validators[i];
        ValidatorValidate(validator, validator.validationGroup, null);
    }
    ValidatorUpdateIsValid();
}

function FourDTermsValidate(source, args) {
    var checkBox = $get("cbTerms");
    if (checkBox) args.IsValid = checkBox.checked;
    else args.IsValid = true;  //let server check
}

var InitialiseRegisterPage = function () {
    $('.registrationTerms').change(validateTerms);
}

//Initialise Controls and Pages
if (typeof (InitialiseRegisterPage) == 'function' && $('.registerPage').length > 0)
    InitialiseRegisterPage();
if (typeof (InitialiseRegisterLogin) == 'function' && $('.registerLoginPage').length > 0)
    InitialiseRegisterLogin();
